import React from "react";

/**
 * One column of the Workbench. Scrolls independently, carries `min-width: 0`
 * so a wide child can never widen the grid, and renders a sticky header that
 * content scrolls underneath.
 *
 * Props:
 *   role     "rail" | "center" | "inspector"
 *   header   { label, count?, action? } | null
 */

const PANE_ELEMENTS = {
  rail: "aside",
  center: "main",
  inspector: "aside",
};

const PANE_ROLES = {
  rail: "complementary",
  center: "main",
  inspector: "complementary",
};

function WorkbenchPane({
  role = "center",
  header = null,
  className = "",
  children,
}) {
  const Element = PANE_ELEMENTS[role] || "section";
  const ariaLabel =
    header?.label || (role === "center" ? "Editor" : `${role} panel`);

  return (
    <Element
      className={`wb-pane wb-pane--${role} ${className}`.trim()}
      role={PANE_ROLES[role] || "region"}
      aria-label={ariaLabel}
      data-pane={role}
    >
      {header ? (
        <div className="wb-pane__hd">
          <h2 className="wb-pane__hd-label">
            <span className="wb-pane__hd-text">{header.label}</span>
            {header.count !== undefined && header.count !== null ? (
              <span className="wb-pane__hd-count">{header.count}</span>
            ) : null}
          </h2>
          {header.action ? (
            <div className="wb-pane__hd-action">{header.action}</div>
          ) : null}
        </div>
      ) : null}
      <div className="wb-pane__body">{children}</div>
    </Element>
  );
}

export default WorkbenchPane;
